import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"

const observabilityTools = [
  { name: "Grafana", description: "Visualize metrics and logs" },
  { name: "Loki", description: "Log aggregation system" },
  { name: "ClickHouse", description: "Column-oriented database for analytics" },
  { name: "Jaeger", description: "Distributed tracing system" },
  { name: "OpenTelemetry", description: "Observability framework for cloud-native software" },
  { name: "VictoriaMetrics", description: "High-performance time series database and monitoring solution" },
]

export default function Observability() {
  return (
    <section id="observability" className="py-20">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold mb-12 text-center">Observability Stack</h2>
        <p className="text-xl mb-8 text-center max-w-3xl mx-auto">
          PentAGI supports a comprehensive observability stack to monitor and analyze your penetration testing processes.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {observabilityTools.map((tool, index) => (
            <Card key={index}>
              <CardHeader>
                <CardTitle>{tool.name}</CardTitle>
                <CardDescription>{tool.description}</CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}

